<template>
    <div @click="(event) => isOutside(event)">
       <modal :width="width" :height="height"  @hide-modal="close">
        <template v-slot:content>
            <div class="modal-inner w-full px-2" v-if="formSteps.length !== 0">
                <IntakeForm class="relative" v-if="formSteps[currentStep].formTitle" :steps="formatFormSteps(formSteps[currentStep].questions)" :fieldsToMonitor="fieldsToMonitor(formSteps[currentStep].questions)" :buttonText="buttonText" :buttonStyling="'items-right'" @submitHandler="contactUsHandler" :showButton="true" @progress="next" @hide-modal="$emit('hide-modal')">
                    <template v-slot:content>
                        <div class="text-left">
                            <div class="text-2xl font-bold pb-1/2">{{formSteps[currentStep].formHeader}}</div>
                            <hr class="pb-1/2"/>
                            <div class="text-base pb-1">{{formSteps[currentStep].formSubHeader}}</div>
                        </div>
                    </template>
                </IntakeForm>
                <component
                    v-else
                    :is="formSteps[currentStep].type"
                    :isAnonymous='isAnonymousCustomer'
                    :step="formSteps[currentStep]"
                    :buttonStyling="'items-center'"
                    :showButton="true"
                    @progress="next"
                >
                <template v-slot:header-content>
                    <div class="text-center space-bottom-1">
                        <div class="text-2xl font-bold" v-if="formSteps[currentStep].title">{{formSteps[currentStep].title}}</div>
                        <div class="text-base space-top-1" v-if="formSteps[currentStep].subTitle">{{formSteps[currentStep].subTitle}}</div>
                    </div>
                </template>
                </component>
            </div>
        </template>
       </modal>
    </div>
            
</template>

<script>

import { mapGetters } from 'vuex';
import IntakeForm from '../webstore/IntakeForm.vue'
import Modal from '../../utils/modal';
import { WebstoreResources } from "../../../mixins/webstore-resources";
import informational from "../webstore/Information"
import { getByContentType } from "../../../plugins/contentful";
import { analyticsTrack } from "../../../plugins/segment";
import axios from 'axios';
export default {
    components: {IntakeForm, Modal, informational},
    mixins: [WebstoreResources],
    props: {
        buttonText: {
            type: String,
            required: true
        },
        locale: {
            type: String,
            required: true,
        },
    },
    data() {
      return {
        formSteps: [],
        currentStep: 0
      }
    },
    computed: {
        ...mapGetters(["isPhoenixCustomer, isPhoenixPhaseTwoCustomer", "typeOfRenewal", "applicationVersion", "productSource"]),
        ...mapGetters("checkout", ["opptyId", "accountId"]),
        width() {
            return window.innerWidth > 550 ? '600px' : '90%';
        },
        height() {
            return window.innerWidth > 550 ? 'auto' : '90%';
        }
    },
    methods: {
        formatFormSteps(formSteps) {
            return formSteps.map((step) => step.fields);
        },
        next(){
            this.currentStep++;
            if (this.currentStep === this.formSteps.length) {
                analyticsTrack("Contact Us Confirmation Modal Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal');
            }
        },
        isOutside(event) {
            if (!event.target.closest('.modal-inner')) {    
                analyticsTrack("Contact Us Form Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                this.$emit('hide-modal');
            }
        },
        close() {
            analyticsTrack("Contact Us Form Closed", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
            this.$emit('hide-modal')
        },
        fieldsToMonitor(formFields){
            let fields = []
            for(let i = 0; i < formFields.length; ++i){
                fields.push(formFields[i]?.fields?.name)
            }
            return fields;
        },
        contactUsHandler(payload){
            try{
                analyticsTrack("Contact Us Form Submit Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal, "source": this.productSource});
                axios.post('/checkout/renewal-contact-us',
                {'message': payload.renewalsContactUsNowMessage, 'phone': payload.anonymousPhone, 'name': payload.anonymousName}
                );
            }
            catch(e){

            }
        }
    },
    async created(){
        analyticsTrack("Renewal Contact Us Button Clicked", {"accountId": this.accountId, "opptyId": this.opptyId, "version": this.applicationVersion, "phase": this.typeOfRenewal});
        const form = await getByContentType("anonymousPricingForm", this.locale, {include : 10, "fields.formTitle": "Renewals- Contact Us Form"});
        this.formSteps = this.formatFormSteps(form.questions);
     },
}
</script>

<style lang="scss" scoped>
input[type=tel] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}

hr.bottom-border {
    width:100% !important
}
</style>